import axios from 'axios';
import _ from 'lodash';
import qs from 'qs';

import config from '../../config';

const baseURL = () => {
	const apiUrl = config.REACT_APP_API_URL || "http://localhost:4000/";
	return apiUrl;
};

const getInstance = ()=>{
	const token = localStorage.getItem('token');
	return axios.create({
		headers: {'Authorization': `Bearer ${token}`},
		baseURL: baseURL(),
	});
}

const handleResponse = (response)=> {
	if (response.status >= 200 && response.status < 300){
		return { error: null, json: response.data, statusCode: response.status, message: response.data.message};
	}
}

const handleError = (errorObject) => {
	return { 
		error: errorObject.response.status, 
		json: errorObject.response.data.body, 
		statusCode: errorObject.response.status,
		message: errorObject.response.data.message,
	};
}

const LandmarksAPI = {
	signIn: (credentials) => {
		let url = `${baseURL()}auth/signin`;
		return axios.post(url, credentials).then(handleResponse).catch(handleError);
	},
	createGeofence: (geofence) => {
		let url = `${baseURL()}api/demo/geofences`;
		return getInstance().post(url, geofence).then(handleResponse).catch(handleError);
	},
	getGeofence: (geofenceId) => {
		let url = `${baseURL()}api/demo/geofences/${geofenceId}`;
		return getInstance().get(url).then(handleResponse).catch(handleError);
	},
	getOrganizations: (country) => {
		let url = `${baseURL()}api/organizations`;
		return getInstance().get(url).then(handleResponse).catch(handleError);
	},
	getPOIs: (filters) => {
		let url = `${baseURL()}api/pois/search`;
		return getInstance().post(url, filters).then(handleResponse).catch(handleError);
	},
	getBoundaries: (filters) => {
		let url = `${baseURL()}api/demo/boundaries`;
		return getInstance().post(url, filters).then(handleResponse).catch(handleError);
	},
	getEvents: (startDate, endDate) => {
		const queryString = qs.stringify({
			startDate,
			endDate,
			appId: '5bd93e527eb5c20004811fff',
		});
		let url = `${baseURL()}api/demo/events?${queryString}`;
		return getInstance().get(url).then(handleResponse).catch(handleError);
	},
}

export default LandmarksAPI;


// WEBPACK FOOTER //
// ./src/shared/api/landmarksid.js